import { DefaultApi } from '../../../api';
import { urls } from '../../../urls';
import { getCatchError } from '../../../getCatchError';

const setPostCreateGameFreespin = (params) => {
    return async (dispatch, getState) => {
        try {
            await DefaultApi({
                params,
                method: 'post',
                url: urls.POST_ADD_GAME_FS
            });
            alert('Игра добавлена')
        } catch (error) {
            //todo доделать catch 
            alert('Ошибка добавления')
            getCatchError(error)
        }
    }
}

export {
    setPostCreateGameFreespin as SetPostCreateGameFreespin
}